import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<img\n  class=\"image\"\n  src={{@imgUrl}}\n  alt={{or @imgAlt \"\"}}\n  data-test-media-modal-image\n>\n")